import { BaseDto } from '@/core';

export class QNAReplyCreateDto extends BaseDto<QNAReplyCreateDto> {
  content: string;
}
